import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import SellIcon1 from "../assets/images/sell-icon-1.svg";
import SellIcon2 from "../assets/images/sell-icon-2.svg";
import ArrowIcon from '../assets/images/button-arrow.svg';
import { Link } from "react-router-dom"

const SellWithAgent = () => {
  return (
    <div className="why-pre-qualified common-padding">
        <Container>
            <div className="common-header text-center">
                <h2>Sell with a <span>Real Estate</span> partner agent</h2>
                <p>Answer a few questions to connect with a Real Estate partner agent who offers Showcase or explore other selling options — all in 3 minutes with no commitment.</p>
            </div>

            <Row className="g-4 justify-content-center">
                <Col md={6} lg={5}>
                <Card>
                    <img src={SellIcon1} alt=""></img>
                    <h5>Sell for more with Showcase</h5>
                    <p>Select partner agents offer Showcase — a premium listing experience with 3D tours and interactive floor plans — at no extra cost. Showcase listings sell for $7K more on average.1</p>
                </Card>
                </Col>
                <Col md={6} lg={5}>
                <Card>
                    <img src={SellIcon2} alt=""></img>
                    <h5>Maximize your home’s visibility</h5>
                    <p>Real Estate helps you sell your home with partner agents to reach the largest audience of buyers through public listings.</p>
                </Card>
                </Col>
            </Row> 
            <div className="d-flex justify-content-center mt-4 mt-lg-5">
                <Link to={'/find-an-agent'} className="custom-bttn style-3 ani-1 right">
                Get Started <img src={ArrowIcon} alt="Arrow Icon" />
                </Link>
            </div>
        </Container>
    </div>
  );
};

export default SellWithAgent;
